import PageMeta from "../components/common/PageMeta";
import PageContainer from "../components/common/PageContainer";
import PageHeader from "../components/common/PageHeader";
import AuthorizeNetPaymentsCoverage from "../components/dashboard/AuthorizeNetPaymentsCoverage";

export default function AuthorizeNetTransactionsPage() {
  return (
    <div>
      <PageMeta
        title="Chargemont | Authorize.net Transactions"
        description="Authorize.net transactions coverage and import status"
      />
      <PageContainer>
        <PageHeader title="Authorize.net Transactions" />
        <AuthorizeNetPaymentsCoverage />
      </PageContainer>
    </div>
  );
}
